enum ISSUE_COMPARISON_TYPE {
	NEW_ISSUES = 'New Issues',
	RECURRING_ISSUES = 'Reoccurring Issues',
	RESOLVED_ISSUES = 'Resolved Issues'
}

export { ISSUE_COMPARISON_TYPE };
